/**
 * On user activity, schedule silent refresh only when context JWT is within the proactive window.
 */

import { tokenManager } from '@/utils/tokenManager'
import { decodeJWT } from '@/utils/permissionUtils'
import { scheduleDebouncedSilentRefresh } from '@/lib/session/silent-context-refresh'
import {
  ACTIVITY_REFRESH_THROTTLE_MS,
  PROACTIVE_CONTEXT_REFRESH_BEFORE_SEC,
} from '@/lib/session/session-refresh.constants'

let attached = false
let lastThrottle = 0

function maybeScheduleRefresh(): void {
  const now = Date.now()
  if (now - lastThrottle < ACTIVITY_REFRESH_THROTTLE_MS) return
  lastThrottle = now

  const jwt = tokenManager.getToken('contextToken')
  if (!jwt) return

  try {
    const payload = decodeJWT(jwt)
    const expMs = typeof payload.exp === 'number' ? payload.exp * 1000 : 0
    if (!expMs) return
    const remainingSec = Math.floor((expMs - now) / 1000)
    if (remainingSec <= 0) return
    if (remainingSec > PROACTIVE_CONTEXT_REFRESH_BEFORE_SEC) return

    scheduleDebouncedSilentRefresh(600)
  } catch {
    /* ignore */
  }
}

export function initActivitySilenceRefresh(): void {
  if (attached || typeof window === 'undefined') return
  attached = true

  const flush = () => maybeScheduleRefresh()
  window.addEventListener('click', flush, true)
  window.addEventListener('keydown', flush, true)
}
